import moment from 'moment';
import { toThousandCommas } from 'filters';
import { mustParse } from 'utils/json';

export default {
  keys: [
    {
      title: '배정된 담당자',
      column: 'assignUserName',
      filter: (o) =>
        `${
          o.assignUserId !== null ? `<span>${o.assignUser.name}</span>` : '-'
        }`,
    },
    {
      title: '상담문의일',
      column: 'requestAt',
      filter: (o) => moment(o.requestAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '매체',
      column: 'mediaId',
      filter: (o) => o.media?.tag,
    },
    {
      title: '이벤트명',
      column: 'eventName',
    },
    {
      title: '이벤트 유형',
      column: 'eventType',
    },
    {
      title: '이벤트 가격',
      column: 'price',
      filter: (o) => (o.price !== null ? toThousandCommas(o.price) : ''),
    },
    {
      title: '방문희망일',
      column: 'visitAt',
      filter: (o) =>
        o.visitAt !== null ? moment(o.visitAt).format('YYYY-MM-DD HH:mm') : '',
    },
    {
      title: '관심항목',
      column: 'interestItem',
    },
    {
      title: '고객문의',
      column: 'memo',
    },
    {
      title: '메모',
      filter: (o) => {
        let arr = mustParse(
          o.consultingRequestResult.length ? o.consultingRequestResult : ''
        );
        return `<div class="flex-row">
                <div class="memo-list">
                ${
                  (arr || []).length > 0
                    ? arr
                        .map(
                          (memoItem, idx) =>
                            `<div class="memo-item index-${idx}">${memoItem.memo}</div>`
                        )
                        .join('')
                    : ''
                }
                </div>
            </div>`;
      },
      style: {
        minWidth: '300px',
      },
    },
  ],
};
